import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';
import notification from '@tt/components/Notification';
import { CONSTANT_VARIABLES } from '../../../views/common/Constant_Variables/constants';

function* fetchMaintenanceDashboardData({ maintenanceDashboardParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: 'maintenancejob/dashboard',
      params: maintenanceDashboardParams,
    });
    const maintenanceDashboardData = data;
    yield put(Actions.setMaintenanceDashboardData({ maintenanceDashboardData }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    console.warn(err); // Handle exception
    notification('error', err.toString(), '');
    yield put(Actions.setLoader({ showLoader: false }));
  }
}

function* fetchMaintenanceJobs() {
  try {
    const { data } = yield call(api.get, {
      route: 'maintenancejob/maintenancedata',
    });
    const maintenanceJobsData = data;
    yield put(Actions.setMaintenanceJobs({ maintenanceJobsData }));
  } catch (err) {
    console.warn(err); // Handle exception
    notification('error', err.toString(), '');
  }
}

function* fetchFactoryLabours({ factoryId }) {
  try {
    const { data } = yield call(api.get, {
      route: 'labour/getlaboursbyfactoryid/' + factoryId,
    });
    const factoryLaboursData = data;
    yield put(Actions.setFactoryLabours({ factoryLaboursData }));
  } catch (err) {
    console.warn(err); // Handle exception
    notification('error', err.toString(), '');
  }
}

function* fetchFactoryDepartments({ factoryId }) {
  try {
    const { data } = yield call(api.get, {
      route: 'department/factory/' + factoryId,
    });
    const factoryDepartmentsData = data;
    yield put(Actions.setFactoryDepartments({ factoryDepartmentsData }));
  } catch (err) {
    console.warn(err); // Handle exception
    notification('error', err.toString(), '');
  }
}

function* fetchPartListByPartType({ partType }) {
  try {
    const { data } = yield call(api.get, {
      route: 'part/getpartsbyparttype/' + partType,
    });
    const partListData = data;
    yield put(Actions.setPartListByPartType({ partListData }));
    if (!partListData) {
      notification('error', 'NO part type exist');
    }
  } catch (err) {
    console.warn(err); // Handle exception
    notification('error', err.toString(), '');
  }
}

function* fetchMaintenanceImagesByJob({ jobId }) {
  try {
    yield put(Actions.setUploadMaintenanceImageLoaderStatus({ maintenanceUploadImageLoader: true }));
    yield put(Actions.setMaintenanceImagesByJobLoaderStatus({ maintenanceImageLoader: true }));
    const { data } = yield call(api.get, {
      route: 'maintenancejob/maintenanceimages/' + jobId,
    });
    const maintenanceImagesListData = data;
    yield put(Actions.setMaintenanceImagesByJob({ maintenanceImagesListData }));
    yield put(Actions.setMaintenanceImagesByJobLoaderStatus({ maintenanceImageLoader: false }));
    yield put(Actions.setUploadMaintenanceImageLoaderStatus({ maintenanceUploadImageLoader: false }));
  } catch (err) {
    console.warn(err); // Handle exception
    notification('error', err.toString(), '');
    yield put(Actions.setMaintenanceImagesByJobLoaderStatus({ maintenanceImageLoader: false }));
    yield put(Actions.setUploadMaintenanceImageLoaderStatus({ maintenanceUploadImageLoader: false }));
  }
}

function* addUpdateMaintenanceJob({
  actionType,
  maintenanceObj,
  maintenanceDashboardParams,
  factoryId,
  maintenanceImage,
}) {
  try {
    const data = { maintenanceJob: maintenanceObj, maintenanceImage };
    yield put(Actions.setLoader({ showLoader: true }));
    if (actionType === CONSTANT_VARIABLES.ADD) {
      yield call(api.post, {
        route: 'maintenancejob/CreateMaintenanceJob',
        data: data,
      });
    }
    if (actionType === CONSTANT_VARIABLES.UPDATE) {
      yield call(api.put, {
        route: 'maintenancejob',
        data: maintenanceObj,
      });
    }
    notification(
      'success',
      actionType === CONSTANT_VARIABLES.ADD
        ? CONSTANT_VARIABLES.MAINTENANCE_MANAGEMENT_JOB_SUCCESS_ADD
        : CONSTANT_VARIABLES.MAINTENANCE_MANAGEMENT_JOB_SUCCESS_UPDATE,
      ''
    );
    yield put(Actions.fetchFactoryLabours({ factoryId }));
    yield put(Actions.fetchFactoryDepartments({ factoryId }));
    yield put(Actions.fetchMaintenanceJobs());
    yield put(Actions.fetchMaintenanceDashboardData({ maintenanceDashboardParams }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(err); // Handle exception
    notification('error', err.toString(), '');
  }
}

function* uploadMaintenanceImage({ payload }) {
  try {
    yield put(Actions.setUploadMaintenanceImageLoaderStatus({ maintenanceUploadImageLoader: true }));
    yield call(api.post, {
      route: 'maintenancejob/UploadImages',
      data: payload,
    });
    notification('success', CONSTANT_VARIABLES.MAINTENANCE_MANAGEMENT_JOB_SUCCESS_UPLOAD, '');
    yield put(Actions.setUploadMaintenanceImageLoaderStatus({ maintenanceUploadImageLoader: false }));
  } catch (err) {
    console.warn(err); // Handle exception
    notification('error', err.toString(), '');
    yield put(Actions.setUploadMaintenanceImageLoaderStatus({ maintenanceUploadImageLoader: false }));
  }
}

function* deleteMaintenanceJob({ maintenanceObj, maintenanceDashboardParams, factoryId }) {
  try {
    yield call(api.delete, {
      route: 'maintenancejob/' + maintenanceObj.id,
    });
    notification('success', CONSTANT_VARIABLES.MAINTENANCE_MANAGEMENT_JOB_SUCCESS_DELETE, '');
    yield put(Actions.fetchFactoryLabours({ factoryId }));
    yield put(Actions.fetchFactoryDepartments({ factoryId }));
    yield put(Actions.fetchMaintenanceJobs());
    yield put(Actions.fetchMaintenanceDashboardData({ maintenanceDashboardParams }));
  } catch (err) {
    console.warn(err); // Handle exception
    notification('error', err.toString(), '');
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(ActionTypes.FETCH_MAINTENANCE_DASHBOARD_DATA, fetchMaintenanceDashboardData),
    takeLatest(ActionTypes.FETCH_MAINTENANCE_JOBS, fetchMaintenanceJobs),
    takeLatest(ActionTypes.FETCH_FACTORY_LABOURS, fetchFactoryLabours),
    takeLatest(ActionTypes.FETCH_FACTORY_DEPARTMENTS, fetchFactoryDepartments),
    takeLatest(ActionTypes.FETCH_PART_LIST_BY_PART_TYPE, fetchPartListByPartType),
    takeLatest(ActionTypes.FETCH_MAINTENANCE_IMAGES_BY_JOB, fetchMaintenanceImagesByJob),
    takeLatest(ActionTypes.ADD_UPDATE_MAINTENANCE_JOB, addUpdateMaintenanceJob),
    takeLatest(ActionTypes.UPLOAD_MAINTENANCE_IMAGE, uploadMaintenanceImage),
    takeLatest(ActionTypes.DELETE_MAINTENANCE_JOB, deleteMaintenanceJob),
  ]);
}
